import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import {
    type ApplicationMarketTypeFragmentFragment,
    type StandardApplicationModuleInDealerSpecsFragment,
} from '../../../../api/fragments';
import { ModuleType } from '../../../../api/types';
import DisclaimersDrawerField from '../../../../components/fields/DisclaimersDrawerField';
import CollapsibleWrapper, { Panel } from '../../../../components/wrappers/CollapsibleWrapper';
import useMarkDownInfoTooltip from '../../../../utilities/useMarkDownInfoTooltip';
import MarketTypeEditableField from './MarketTypeEditableField';

type DealerMainDetailsSectionProps = {
    marketType: ApplicationMarketTypeFragmentFragment;
    module: StandardApplicationModuleInDealerSpecsFragment;
    disabled?: boolean;
};
const DealerMainDetailsSection = ({ marketType, module, disabled }: DealerMainDetailsSectionProps) => {
    const { t } = useTranslation(['moduleDetails', 'dealershipManagement']);
    const markdownInfoTooltip = useMarkDownInfoTooltip(marketType.type);

    return (
        <CollapsibleWrapper defaultActiveKey="dealerMainDetails">
            <Panel key="dealerMainDetails" header={t('dealershipManagement:tabs.panel.mainDetails')}>
                <Row gutter={14}>
                    <MarketTypeEditableField disabled={disabled} marketType={module.marketType} />
                    {module.__typename === ModuleType.StandardApplicationModule && (
                        <Col md={8} xs={24}>
                            <DisclaimersDrawerField
                                {...t('moduleDetails:fields.priceDisclaimerTitle', { returnObjects: true })}
                                disabled={disabled}
                                disclaimerKind="priceDisclaimer"
                                name="dealerPriceDisclaimer"
                                tooltip={markdownInfoTooltip}
                            />
                        </Col>
                    )}
                </Row>
            </Panel>
        </CollapsibleWrapper>
    );
};

export default DealerMainDetailsSection;
